import React from 'react';

import { Form } from 'antd';
import { FaLock } from 'react-icons/fa';

import { FormInput } from '@src/components/atoms/form/form-input';
import { GradientButton } from '@src/components/molecules/gradient-button';
import { Heading12, Paragraph1 } from '@src/theme';

import { StyledResetForm } from './styles';
import { bemClassName } from '../../../../utils/bem';

const b = bemClassName('reset-form');

const PASSWORD_RULES = [
  { required: true, message: 'Please input your password!' },
  { min: 8, message: 'Password must be at least 8 characters long!' },
  { pattern: /[A-Z]/, message: 'Password must contain at least one uppercase letter!' },
  { pattern: /[0-9]/, message: 'Password must contain at least one number!' },
  { pattern: /[^A-Za-z0-9]/, message: 'Password must contain at least one special character!' },
];

const ResetForm = ({ token, id, onReset, loading }) => {
  const [form] = Form.useForm();

  return (
    <StyledResetForm>
      <Form
        className={b()}
        form={form}
        layout="vertical"
        onFinish={(values) => onReset({ password: values.password, token, id })}
        initialValues={{
          password: '',
          confirmPassword: '',
        }}
      >
        <div className={b('header')}>
          <div className={b('icon')}>
            <FaLock />
          </div>
          <div className={b('title')}>
            <Heading12>Reset Password</Heading12>
          </div>
          <div className={b('subtitle')}>
            <Paragraph1>Enter your new password below to regain access to your account.</Paragraph1>
          </div>
        </div>

        <div className={b('item')}>
          <FormInput
            name="password"
            label="New password"
            rules={PASSWORD_RULES}
            icon={<FaLock />}
            isPassword
            form={form}
          />
        </div>

        <div className={b('item')}>
          <FormInput
            name="confirmPassword"
            label="Confirm new password"
            rules={[
              { required: true, message: 'Please retype your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(new Error('The two passwords do not match!'));
                },
              }),
            ]}
            icon={<FaLock />}
            isPassword
            form={form}
          />
        </div>

        <div className={b('submit')}>
          <Form.Item>
            <GradientButton type={loading ? 'button' : 'submit'} loading={loading} width="auto">
              CONTINUE
            </GradientButton>
          </Form.Item>
        </div>
      </Form>
    </StyledResetForm>
  );
};

export default ResetForm;
